import './HiddenAnnotationsToast.scss';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { IconButton } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Link } from '../../design/links/S_Link';
import { RowLayout } from '../../modules/common/layouts/rowLayout/RowLayout';

interface IProps {
  unhideAllAnnotationTypes: () => void;
  hideToast: () => void;
}

export const HiddenAnnotationsToast = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <div className='toast-container'>
      <div className='toast'>
        <div className='toast-header'>
          <RowLayout
            size='sm'
            className='toast-header-content'
          >
            <FontAwesomeIcon icon={faExclamationTriangle} />
            <span>{t('warning')}</span>
          </RowLayout>
          <IconButton
            onClick={props.hideToast}
            size='sm'
          >
            <FontAwesomeIcon icon={'times'} />
          </IconButton>
        </div>
        <div className='toast-body'>
          <span>
            {t('some_annotations_are_hidden')} <br />
          </span>
          <S_Link
            className='toast-body-link'
            color='text'
            onClick={props.unhideAllAnnotationTypes}
          >
            {t('click_here_to_unhide_all')}
          </S_Link>
        </div>
      </div>
    </div>
  );
});
